// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"file_Wrapper__pa7_X","Icon":"file_Icon__F65b7","Name":"file_Name__SSNoa"};